import { render, staticRenderFns } from "./CustomLinkTile.vue?vue&type=template&id=b5eb70e4&scoped=true&"
var script = {}
import style0 from "./CustomLinkTile.vue?vue&type=style&index=0&id=b5eb70e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eb70e4",
  null
  
)

export default component.exports